var index = (function () { return window.__PUBLIC_STATE__; });

var index$1 = (function (fieldName, schema) {
    var validationSchema = Object(schema).hasOwnProperty("_resolve")
        ? schema._resolve()
        : schema;
    return validationSchema.fields[fieldName]
        ? validationSchema.fields[fieldName].tests.some(function (_a) {
            var TEST_NAME = _a.TEST_NAME;
            return TEST_NAME === "required";
        })
        : false;
});

var index$2 = (function () {
    var pageID = window.__PUBLIC_STATE__ && window.__PUBLIC_STATE__.page.id;
    return pageID;
});

var pluralise = (function (resource) {
    switch (resource) {
        case 'actor':
        case 'article':
        case 'application':
        case 'company_user':
        case 'user':
        case 'role':
        case 'broker':
        case 'product':
        case 'package':
        case 'product':
        case 'purchase':
        case 'document':
        case 'group':
        case 'sector':
        case 'sequence':
        case 'tag':
        case 'insurer':
        case 'feature':
        case 'content':
        case 'insurance_product':
        case 'account_import':
        case 'account_import_job':
        case 'insurance product':
        case 'team':
        case 'company_team':
        case 'question':
        case 'influence_question':
        case 'question_document':
        case 'risk':
        case 'questionnaire':
        case 'area':
        case 'source':
        case 'value':
        case 'tag': {
            return resource + "s";
        }
        case 'company':
        case 'country':
        case 'category':
        case 'property':
        case 'policy': {
            return resource.slice(0, -1) + "ies";
        }
        case 'news': {
            return resource;
        }
        default: {
            console.error('No case to pluralise resource', resource);
            return resource;
        }
    }
});

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var capitalise = (function (str) { return str.charAt(0).toUpperCase() + str.slice(1); });

var alertify = require("alertifyjs");
function styledAlert(type, message, persist, count) {
    if (type === void 0) { type = "success"; }
    if (message === void 0) { message = ""; }
    if (persist === void 0) { persist = false; }
    if (count) {
        for (var index = 0; index < count; index++) {
            alertify.notify("<span class=\"message " + (persist ? "close-arrow" : "") + "\">" + message + "</span> ", type, persist ? 0 : 5);
        }
    }
    else {
        alertify.notify("<span class=\"message " + (persist ? "close-arrow" : "") + "\">" + message + "</span> ", type, persist ? 0 : 5);
    }
}
function styledConfirm(message, successCb, failureCb, title, labels) {
    alertify
        .confirm(message, successCb, failureCb)
        .set(title)
        .set({ labels: labels });
}
function styledPrompt(message, defaultValue, successCb, failureCb, title, labels) {
    if (defaultValue === void 0) { defaultValue = "Rename"; }
    alertify
        .prompt(message, defaultValue, successCb, failureCb)
        .set(title)
        .set({ labels: labels });
}

var FormAlertHandler = /** @class */ (function () {
    function FormAlertHandler() {
        this.successMessage = "Saved!";
    }
    FormAlertHandler.prototype.displaySuccess = function (response) {
        styledAlert("success", response.message);
    };
    FormAlertHandler.prototype.displayGenericSuccessMessage = function () {
        styledAlert("success", this.successMessage);
    };
    FormAlertHandler.prototype.displayWarnings = function (warnings) {
        var message = "\n        <p>Form was partially saved however there were some errors:</p>\n        <ul>\n          " + this.getErrorsList(this.getErrorMapFromWarnings(warnings)) + "\n        </ul>\n      ";
        styledAlert("warning", message, true, warnings.length);
    };
    FormAlertHandler.prototype.displayErrors = function (response) {
        var message;
        var errors;
        try {
            message = response.message;
            errors = this.getErrorsList(response.errors);
        }
        catch (error) {
            message = "Server error";
            errors = ["<li>Unknown error</ul>"];
        }
        styledAlert("error", "\n        <p>" + message + ":</p>\n        <ul>\n          " + errors.map(function (error) { return "<li>" + error + "</li>"; }).join("") + "\n        </ul>\n      ", true, response.errors ? Object.keys(response.errors).length : 1);
    };
    FormAlertHandler.prototype.getErrorMapFromWarnings = function (warnings) {
        // NOTE: If there are keys of the same name, both with warnings, they will be lost here
        return warnings
            .map(function (warning) {
            return warning.errors || {
                message: ["returned from API with no errors object"]
            };
        })
            .reduce(function (acc, cv) { return (__assign({}, acc, cv)); }, {});
    };
    FormAlertHandler.prototype.getErrorsList = function (errors) {
        var errorArray = [];
        if (Array.isArray(errors)) {
            errorArray = errors;
        }
        else {
            errorArray = this.convertErrorObjectToArray(errors);
        }
        return errorArray;
    };
    FormAlertHandler.prototype.convertErrorObjectToArray = function (errorObject) {
        var errorArray = [];
        Object.entries(errorObject).forEach(function (_a) {
            var field = _a[0], errors = _a[1];
            errors.forEach(function (error) {
                var message = field.toLowerCase() === "base"
                    ? capitalise(error)
                    : capitalise(field.split("_").join(" ")) + " " + error;
                errorArray = errorArray.concat([message]);
            });
        });
        return errorArray;
    };
    return FormAlertHandler;
}());

var index$3 = (function (resource) {
    switch (resource) {
        case "api_key": {
            return "/profile/api-keys";
        }
        default: {
            return "/" + pluralise(resource);
        }
    }
});

var Cookies = require("js-cookie");
var index$4 = (function (sessionName) { return Cookies.get(sessionName); });

export { FormAlertHandler, capitalise, index$2 as getPageId, index$3 as getResourcePageUrl, index$4 as getSessionToken, index as getState, index$1 as isFieldRequired, pluralise, styledAlert, styledConfirm, styledPrompt };
